import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "../../context/ToastContext";
import ProductionUnitApi from "../../services/ProductionUnitApi";

// Design System
import Input from "../../components/Input/Input";
import FormCard from "../../components/FormCard/FormCard";

const ProductionUnitDetails: React.FC = () => {
  const { t: translateForm } = useTranslation("form");
  const { t: translateGeneral } = useTranslation("general");
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { displayToast } = useToast();

  const [name, setName] = useState<string>("");
  const [plantLabel, setPlantLabel] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      navigate("/production-units");
      return;
    }

    const fetchProductionUnit = async (puId: string): Promise<void> => {
      try {
        const resp = await ProductionUnitApi.GetProductUnitById(puId);
        if (resp.success && resp.data) {
          const unit = resp.data;
          setName(unit.name || "");
          setPlantLabel(unit.plant?.name || unit.plantName || "—");
        }
      } catch (err: any) {
        displayToast("error", translateForm("error"), err.message || "", false, 3000);
        navigate("/production-units");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductionUnit(id);
  }, [id, navigate, displayToast, translateForm]);

  const handleBack = (): void => {
    navigate("/production-units");
  };

  if (isLoading) {
    return <div className="p-4">{translateGeneral("loading")}...</div>;
  }

  return (
    <FormCard
      title={translateForm("productionUnitDetails")}
      icon="info"
      onSubmit={() => {}}
      onCancel={handleBack}
      cancelButtonLabel={translateForm("back") || "Voltar"}
      numColumns={12}
      disabled
    >
      {/* Planta */}
      <div style={{ gridColumn: "span 6" }}>
        <Input
          type="text"
          label={translateForm("plant") || "Planta"}
          value={plantLabel}
          onChange={() => {}}
          disabled
        />
      </div>
      
      {/* Nome da Unidade */}
      <div style={{ gridColumn: "span 6" }}>
        <Input
          type="text"
          label={translateForm("name") || "Nome da Unidade"}
          value={name}
          onChange={() => {}}
          disabled
        />
      </div>
    </FormCard>
  );
};

export default ProductionUnitDetails;


